import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { LsxphongCanKetQuaSx } from '../ghi-nhan-kqsx-phong-can-model/ghi-nhan-kqsx-phong-can.model';

const API_ROOT_URL = environment.ApiRoot + '/sanxuat';

@Injectable()
export class GhiNhanKQSXPhongCanService {

	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});

	//lastData$: BehaviorSubject<KhKeHoachSanXuatInteraction[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method----------------------------- */
	getListGhiNhanKQSXPhongCan_BaseOnListDate(listDate: any[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/SX_GhiNhanKQSXPhongCan_BaseOnDate`;
		return this.http.post<any>(url, listDate, { headers: httpHeaders });
	}
	getDetailGhiNhanKQSXPhongCan(id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/SX_GhiNhanKQSXPhongCan_Detail?id=${id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */

	/*-------------------------------POST Method---------------------------- */
	getNPLOfCTFromBOM(item: LsxphongCanKetQuaSx): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/SX_GhiNhanKQSXPhongCan_GetNPLFromBOM', item, { headers: httpHeaders });
	} 
	/*---------------------------------------------------------------------- */

	/*------------------------------ Qui trình ----------------------------- */
	guiKiemTraKQSXPhongCan(item: LsxphongCanKetQuaSx): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/SX_GhiNhanKQSXPhongCan_KiemTra', item, { headers: httpHeaders });
	}
	kiemTraKQSX(item: LsxphongCanKetQuaSx): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/SX_GhiNhanKQSXPhongCan_Approve', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */

	
}
